<template>
    <div class="logo">
        <img :src="Web.Url(appData.default.logo)" :alt="appData.name">
    </div>
    <div class="card">
        <div class="card-header">
            <div class="title">
                <span>SAYFA BULUNAMADI</span>
            </div>
        </div>
        <div class="card-body">
            <div class="mb-3 text-center">
                <i class="fa fa-warning text-warning"></i>
                <p>Üzgünüz, istediğiniz sayfa bulunamadı.</p>
            </div>
        </div>
        <div class="card-footer">
            <router-link class="btn btn-primary" :to="Links.Url(Links.Home)">
                <i class="fa fa-house"></i>
                <span>Anasayfaya Git</span>
            </router-link>
            <button class="btn btn-secondary" @click="$router.back()">
                <i class="fa fa-rotate-left"></i>
                <span>Geri Dön</span>
            </button>
        </div>
    </div>
</template>
<script>
export default {
  name: "PageNotFound",
};
</script>
